import React from "react";

import EditSelect from "@ui/inputs/EditSelect";

import styles from "./styles.module.scss";

export const Filters = ({filtersList}) => {
  return (
    <div className={styles.filters}>
      {filtersList &&
        filtersList.length > 0 &&
        filtersList.map((filter) => (
          <div
            className={styles.filter}
            key={filter.id}
          >
            <EditSelect
              placeholder={filter.placeholder}
              searchPlaceholder={filter.searchPlaceholder}
              resetOptionLabel={filter.resetOptionLabel}
              activeOption={filter.activeOption}
              options={filter.options}
              onSelect={filter.onSelect}
              onSearch={filter.onSearch}
              emptyResult={filter.emptyResult}
              multiSelect={filter.multiSelect}
              height={150}
            />
          </div>
        ))}
    </div>
  );
};
